import { acceptDisclaimer } from "../state.js";
import { navigate } from "../main.js";

export function renderDisclaimer(root: HTMLElement) {
  root.innerHTML = `
    <div class="center-stage">
      <div class="center-card">
        <h1>Antes de começar</h1>
        <p>
          Esta ferramenta envia sua senha do <strong>Questor Zen</strong> ao proxy
          <code>questor.addedlabs.com.br</code> <strong>no momento do login</strong>
          para obter os cookies de sessão. Depois disso, apenas os cookies
          trafegam — sua senha não é armazenada nem enviada novamente.
        </p>
        <p>
          <strong>Nada é gravado em banco de dados.</strong> Nada do que você
          visualizar fica em servidor — apenas na memória do seu navegador
          enquanto a aba estiver aberta.
        </p>
        <p>
          Mantenedor: Leandro Oliveira · sem garantias · sem suporte oficial.
        </p>
        <div class="check">
          <input type="checkbox" id="agree" />
          <label for="agree" style="margin: 0; text-transform: none; font-size: 13px; color: var(--ink); letter-spacing: 0;">
            Li e estou de acordo
          </label>
        </div>
        <button class="btn" id="continuar" disabled>Continuar</button>
      </div>
    </div>
  `;
  const cb = root.querySelector<HTMLInputElement>("#agree")!;
  const btn = root.querySelector<HTMLButtonElement>("#continuar")!;
  cb.addEventListener("change", () => (btn.disabled = !cb.checked));
  btn.addEventListener("click", () => {
    if (!cb.checked) return;
    acceptDisclaimer();
    navigate("login");
  });
}
